export default "__VITE_ASSET__D3ekf5tY__"